// Stage 1 "Silent defaults" · group G6 (A-37 … A-44) — screen texts, EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
//   A-37  W11 item 1 / review_1 / review_11: an included form that is not in the forms library reads "not built".
//   A-38  W11 warnings: a warning source that could not be read is a note (code W11_WARNINGS_UNAVAILABLE in the API row and the
//         server log; the screen text carries no code — Batch 15 · N3: no work-paper code on screen), never dropped.
//   A-39  W10 memo form pulls: a forms library that could not be read shows "Unknown", never "Not built yet".
export const I18N_SD_G6 = {
  en: {
    sdG6: {
      w11: {
        notBuilt: "Not built (not in the current forms library)",
        mlWarningUnavailable: "The 322(a) management letter warning could not be read — the detail is in the server log.",
        dcWarningUnavailable: "The Disclosure checklist progress could not be read — the detail is in the server log.",
      },
      w10: {
        libraryUnknown: "Unknown — the forms library could not be read",
      },
    },
  },
  ar: {
    sdG6: {
      w11: {
        notBuilt: "لم يُبنَ (غير موجود في مكتبة النماذج الحالية)",
        mlWarningUnavailable: "تعذّرت قراءة تحذير خطاب الإدارة ⁦322(a)⁩ — التفاصيل في سجل الخادم.",
        dcWarningUnavailable: "تعذّرت قراءة تقدّم قائمة الإفصاحات — التفاصيل في سجل الخادم.",
      },
      w10: {
        libraryUnknown: "غير معروف — تعذّرت قراءة مكتبة النماذج",
      },
    },
  },
};

export default I18N_SD_G6;
